import { mergeDefaults as _mergeDefaults, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row items-center full-width" }
const _hoisted_2 = {
  key: 0,
  class: "text-weight-bold",
  style: {"max-width":"40%"}
}
const _hoisted_3 = {
  key: 1,
  class: "row items-center no-wrap full-width"
}
const _hoisted_4 = { class: "q-ml-sm" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 1,
  class: "text-bold"
}

import isObject from 'lodash/isObject';
import { QTree } from 'quasar';
import { computed, ref } from 'vue';

import {
  BaseFieldEmits,
  ValuedFieldProps,
  defaultValuedProps,
} from 'SharedComponents/Fields/composables/useBaseFieldProps';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { FieldValue } from 'SharedDir/declarations/fields';

interface RawObjectValue {
  name: string | null;
  value: string | Record<string, RawObjectValue> | Array<RawObjectValue>;
}

type ValueType = FieldValue<null | Record<string, RawObjectValue> | Array<RawObjectValue>>;
type Props = ValuedFieldProps & PropValue<ValueType>;


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'ObjectField' },
  __name: 'ObjectField',
  props: /*@__PURE__*/_mergeDefaults({
    readonly: { type: Boolean },
    disable: { type: Boolean },
    required: { type: Boolean },
    useWrapper: { type: Boolean },
    skipValidation: { type: Boolean },
    errorMessage: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    modelValue: {}
  }, defaultValuedProps),
  emits: ["update:modelValue", "reveal-history"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

function key() {
  return Math.round(Math.random() * 1000000000).toString();
}

function makeNode(v) {
  return { children: [], ...v, key: key() };
}

function makeTree(obj: any) {
  if (!isObject(obj)) {
    return `Странный случай ${obj}`;
  }

  if (Array.isArray(obj)) {
    return obj.map(makeArrayItem);
  }

  const { name, value } = obj as any;
  if (Array.isArray(value)) {
    return makeNode({
      name,
      children: value.map(makeArrayItem),
    });
  }
  if (typeof name !== 'undefined' && typeof value !== 'undefined') {
    if (!isObject(value)) {
      return makeNode({ name, value });
    }
    return makeNode({ name, children: Object.values(value).map(makeTree) });
  }

  const mapped = [] as any;
  Object.keys(obj).forEach((key) => {
    mapped.push({ name: key, value: obj[key] });
  });

  return mapped.map((node) => {
    if (isObject(node.value)) {
      node.children = makeTree(node.value);
    }
    return makeNode(node);
  });
}

function makeArrayItem(v) {
  const { name, value } = v as any;
  if (Array.isArray(value)) {
    return makeNode({
      name,
      children: value.map(makeArrayItem),
    });
  }
  if (typeof name !== 'undefined' && typeof value !== 'undefined') {
    // return node({ name, value });
    if (!isObject(value)) {
      return makeNode({ name, value });
    }
    // eslint-disable-next-line no-use-before-define
    return makeNode({ name, children: Object.values(value).map(makeTree) });
  }
  // eslint-disable-next-line no-use-before-define
  return makeNode({ name: '', children: makeTree(v) });
}

/**
 *
 */


const props = __props;
const emit = __emit;

const { innerValue } = useValue(props, emit, { transform: (v) => v ?? [] });

const nodes = computed(() => [
  makeNode({
    name: props.label,
    children: makeTree(innerValue.value.value),
  }),
]);

const noNodes = computed(() => {
  return `${props.label}: не найдено.`;
});

const isUrl = (s: string) => {
  try {
    const url = new URL(s);
    return true;
  } catch {
    return false;
  }
};

const refQTree = ref<QTree>();

function expandAll() {
  return refQTree.value?.expandAll();
}

__expose({ expandAll });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(QTree), {
    ref_key: "refQTree",
    ref: refQTree,
    nodes: nodes.value,
    "node-key": "key",
    "label-key": "name",
    "no-nodes-label": noNodes.value
  }, {
    "default-header": _withCtx((prop) => [
      _createElementVNode("div", _hoisted_1, [
        (prop.node.children.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (prop.node.name)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(prop.node.name), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("{ ... }")
                  ], 64))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", null, _toDisplayString(prop.node.name), 1),
              _createElementVNode("div", _hoisted_4, [
                (isUrl(prop.node.value))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      target: "_BLANK",
                      href: prop.node.value
                    }, _toDisplayString(prop.node.value), 9, _hoisted_5))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(prop.node.value), 1))
              ])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["nodes", "no-nodes-label"]))
}
}

})